import React from "react";
import { getPortabilityParams } from "./getPortabilityParams";

const InfoMainsPortability = () => {
  const portabilityParams = getPortabilityParams();

  return (
    <div>
      <h3>Pedido de portabilidade</h3>
      {!portabilityParams.hideInstructions ? (
        <>
          <p className="card-portability">
            Com a portabilidade você continua com o seu número de celular. Faça
            portabilidade e mude de operadora, não de número.
          </p>
          <h4 className="card-portability">
            É rápido e fácil. Saiba como solicitar sua portabilidade:
          </h4>

          <div className="tips">
            <ul>
              <li>
                <span className="icon-green">1</span> Insira o Chip do Correios
                Celular no seu celular.
              </li>

              <li>
                <span className="icon-green">2</span> Você receberá um SMS
                informando seu número: Lembre-se de anotar.
              </li>
              <li>
                <span className="icon-green">3</span> Agora é só inserir o chip
                da sua operadora antiga no seu celular e preencher os campos
                abaixo.
              </li>
              <li>
                <span className="icon-green">4</span>Será enviado um SMS para o
                número da sua operadora antiga com um link.
              </li>
              <li>
                <span className="icon-green">5</span> Clique no link e aguarde
                até que apareça o botão CONFIRMAR.
              </li>
              <li>
                <span className="icon-green">6</span> Clique no botão para
                confirmar sua solicitação de portabilidade.
              </li>
              <li>
                <span className="icon-green">7</span> Clique no botão para
                confirmar sua portabilidade e acontecerá em até 3 dias úteis.
              </li>
            </ul>
            <p className="card-portability">
              Agora é só aguardar. Assim que validarmos todas as informações
              você receberá um SMS, no <br />
              número da sua antiga operadora, informando: <br />
              <strong>Portabilidade concluída com sucesso!</strong>
            </p>
            <br />
          </div>
        </>
      ) : null}
    </div>
  );
};

export default InfoMainsPortability;
